import BaseAPI from './base';
import { LogListData } from 'types/logs';
import { CollectionQueryParams, CollectionData, ApiPromise, CollectionMeta } from 'types';
import { toQueryString } from 'utilities/url';
import { apiRoutes } from 'utilities/initialize_centre';

const ROUTES = apiRoutes.LOGS;

class LogsAPI extends BaseAPI {
  protected getLogsUrl() {
    return ROUTES.BASE;
  }

  public getLogList(params: CollectionQueryParams): ApiPromise<CollectionData<LogListData>, CollectionMeta> {
    return this.get(`${this.getLogsUrl()}?${toQueryString(params)}`);
  }

  public getLogsExcel() {
    return this.getBlob(`${this.getLogsUrl()}/${ROUTES.GET_LOGS_EXCEL.ROUTE}`, ROUTES.GET_LOGS_EXCEL.BLOB());
  }
}

export default LogsAPI;
